export default __webpack_public_path__ + "static/media/editorShuffler.72900c49.svg";